export default __webpack_public_path__ + "static/media/bag-icon.b37cdd38.svg";